// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessRules_container__q68gn","divider":"BusinessRules_divider__aggmG"};